<script>
  import { onMount } from "svelte";

  export let query;

  let mql;
  let mqlListener;
  let matches = undefined;

  onMount(() => {
    addNewListener(query);
    return () => {
      removeActiveListener();
    };
  });

  function addNewListener(query) {
    mql = window.matchMedia(query);
    mqlListener = (v) => (matches = v.matches);
    mql.addListener(mqlListener);
    matches = mql.matches;
  }

  function removeActiveListener() {
    if (mql && mqlListener) {
      mql.removeListener(mqlListener);
    }
  }
</script>

{#if matches === true}
  <slot />
{:else if matches === false}
  <slot name="else" />
{/if}
